"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var classes = {
  "root": "header-module__root___4MxFA",
  "content": "header-module__content___2Q337"
};

var Header = function Header(_ref) {
  var left = _ref.left,
      children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: classes.root,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: classes.content,
      children: [left, children]
    })
  });
};

exports.Header = Header;